import useSWR from 'swr';

export interface QuotaRow {
  project_id: string;
  slug: string;
  name: string;
  storage_bytes_max: number;
  storage_bytes_used: number;
}

const fetcher = (url: string) =>
  fetch(url, { credentials: 'include' }).then((r) => r.json());

export function useQuotas() {
  return useSWR<QuotaRow[]>('/api/admin/quotas', fetcher);
}

export async function setQuota(projectId: string, q: {
  storage_bytes_max: number;
}): Promise<void> {
  const res = await fetch(`/api/admin/quotas/${projectId}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(q),
  });
  if (!res.ok && res.status !== 204) throw new Error(await res.text());
}
